import * as React from 'react';
import { SVGProps } from 'react';

const SvgBuy = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <rect width={32} height={32} rx={16} fill="#A0D4D3" />
    <path
      d="M6.732 20h2.955c1.503 0 2.417-.762 2.417-1.992v-.01c0-.928-.674-1.621-1.665-1.709v-.024c.756-.103 1.328-.782 1.328-1.538v-.01c0-1.07-.826-1.763-2.11-1.763H6.732V20Zm2.608-6.065c.747 0 1.181.342 1.181.953v.01c0 .664-.488 1.035-1.396 1.035H7.992v-1.998H9.34Zm-.015 2.91c.987 0 1.494.372 1.494 1.08v.01c0 .708-.498 1.084-1.42 1.084H7.991v-2.173h1.333Zm6.577 3.277c1.792 0 2.891-1.05 2.891-2.607v-4.56h-1.255v4.457c0 .977-.59 1.616-1.636 1.616-1.045 0-1.64-.64-1.64-1.616v-4.458h-1.26v4.56c0 1.558 1.113 2.608 2.9 2.608ZM22.025 20h1.255v-2.778l2.471-4.268h-1.377L22.67 16.02h-.034l-1.704-3.066h-1.377l2.47 4.268V20Z"
      fill="#174174"
    />
  </svg>
);

export default SvgBuy;
